import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/nfts/verified.svg'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = {
  class: "trezo-card-content relative md:border-t md:border-b border-primary-50 dark:border-[#172036] md:py-[20px] md:py-[25px]",
  id: "topCollectionsSlides"
}
const _hoisted_3 = { class: "flex items-center gap-[12px] mb-[22px]" }
const _hoisted_4 = { class: "relative ltr:pr-[7px] rtl:pl-[7px]" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "font-semibold text-black dark:text-white inline-block mb-[3px]" }
const _hoisted_7 = { class: "block text-gray-500 dark:text-gray-400 text-xs" }
const _hoisted_8 = { class: "flex items-center gap-[15px]" }
const _hoisted_9 = { class: "w-[100px] md:w-[120px] rounded-md shrink" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "grow-0" }
const _hoisted_12 = { class: "font-semibold text-black dark:text-white text-md md:text-lg mb-[4px]" }
const _hoisted_13 = { class: "block text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }, [
      _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Top Collections")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Swiper, {
        slidesPerView: 1,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          clickable: true,
          el: '.swiper-pagination',
        },
        modules: _ctx.modules,
        class: "mySwiper"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nftItem, (nft) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, {
              key: nft.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: nft.creator.image,
                      class: "rounded-full w-[50px]",
                      alt: "author-image"
                    }, null, 8, _hoisted_5),
                    _cache[0] || (_cache[0] = _createElementVNode("img", {
                      src: _imports_0,
                      class: "absolute ltr:right-0 rtl:left-0 bottom-0",
                      alt: "verified"
                    }, null, -1))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(nft.creator.name), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(nft.creator.items) + " Items ", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      src: nft.image,
                      alt: "top-collection-image",
                      class: "rounded-md"
                    }, null, 8, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(nft.title), 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(nft.subTitle), 1)
                  ])
                ]),
                _createVNode(_component_RouterLink, {
                  to: "/nft-marketplace/nft-details",
                  class: "inline-block font-medium rounded-md mt-[22px] px-[13px] py-[6px] text-primary-500 border border-primary-500 transition-all hover:bg-primary-500 hover:text-white"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("span", { class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px]" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2" }, " add "),
                      _createTextVNode(" View Details ")
                    ], -1)
                  ])),
                  _: 1
                })
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1))
        ]),
        _: 1
      }, 8, ["modules"])
    ])
  ]))
}